import React, {useMemo} from "react";
import {NavLink} from "react-router-dom";
import ContentBox from "../../../../../components/content-box/ContentBox";
import Dependencies from "../../../../../utilities/Dependencies";
import Environment from "../../../../../services/interfaces/Environment";
import PageActions from "../../../../base/PageActions";
import '../../../../styles/Common.scss';
import '../WorldPages.scss';
import '../WorldDynamicContent.scss';
import Breadcrumbs from "../../../../../components/breadcrumbs/Breadcrumbs";

interface BotanaryPageProps {
    dependencies: Dependencies,
    env: Environment
}

const BotanaryPage = (props: BotanaryPageProps) => {

    const page: PageActions = useMemo(() => new PageActions({
        dependencies: props.dependencies,
        env: props.env,
        title: `Casarok Botanary - Chase the Fox`,
        description: "The world of Casarok has a wide variety of plant life that cannot be found anywhere else in the universe!",
        keywords: ["casarok", "botanary", "magic plant", "fantasy plant", "fantasy flora"],
        imgSrc: `chase/world/botanary/yulaberry.png`,
        url: `world/botanary`
    }), [props]);

    return page.generateMetaContent(
        <>
            <ContentBox header="Botanary">
                <Breadcrumbs path={page.getUrl()}/>
                <p>
                    Casarok is home to many different species of plants. While most of them are similar to those found
                    on Earth, many new species of plants have arisen through the ages and the magical nature of the
                    planet. These unique flora empowered the denizens of early Casarok, and some are still in use to
                    this very day.
                </p>
                <p>
                    Please note that the botanary here does not take into account the classification of life known as
                    <NavLink className="world-link" to="/world/bestiary/floradon">Floradons</NavLink>. These are
                    all non-sentient plant life the previously mentioned classification is maintained separately from
                    this group.
                </p>
                <p>
                    A listing of the various species of plant life unique to Casarok are listed here:
                </p>
                <div className="character-lineup world-page-static">
                    <div>
                        <NavLink className="world-link block" to="/world/botanary/ironvine">
                            <img src={page.image().getCdnImageSrc(`chase/world/botanary/ironvine.png`)}
                                 alt="An Ironvine plant, one of the strongest flora in Casarok"
                                 title="An Ironvine plant, one of the strongest flora in Casarok"/>
                            Ironvine
                        </NavLink>
                    </div>
                    <div>
                        <NavLink className="world-link block" to="/world/botanary/yulaberry">
                            <img src={page.image().getCdnImageSrc(`chase/world/botanary/yulaberry.png`)}
                                 alt="A bough bearing yulaberries, a favorite fruit in northern Casarok"
                                 title="A bough bearing yulaberries, a favorite fruit in northern Casarok"/>
                            Yulaberry
                       </NavLink>
                    </div>
                </div>
            </ContentBox>
        </>
    );
}

export default BotanaryPage;